<script>
import VTextField from 'vuetify/es5/components/VTextField/VTextField'
export default {
  extends: VTextField,
  name: 'v-numeric-text-field',
  methods: {
    genInput () {
      const listeners = Object.assign({}, this.$listeners)
      delete listeners['change'] // Change should not be bound externally

      return this.$createElement('input', {
        style: {},
        domProps: {
          value: this.lazyValue
        },
        attrs: {
          ...this.$attrs,
          autofocus: this.autofocus,
          disabled: this.disabled,
          id: this.computedId,
          placeholder: this.placeholder,
          readonly: this.readonly,
          type: this.type
        },
        on: Object.assign(listeners, {
          blur: this.onBlur,
          input: this.onInput,
          focus: this.onFocus,
          keydown: this.onKeyDown,
          keypress: this.keyPress // nuestro código
        }),
        ref: 'input'
      })
    },
    keyPress (e) {
      if (e.code === 'Decimal' || e.code === 'Period') {
        e.preventDefault()
        e.stopPropagation()
        this.inputValue += ','
      }
    }
  }
}
</script>